import LegalLayout, { P, H2, UL } from "./LegalLayout";

export default function About() {
  return (
    <LegalLayout title="About Us" updated="February 2026">
      <P>Vendorly (<strong>grahakly.app</strong>) is a WhatsApp-first customer relationship platform purpose-built for small offline vendors in India — grocery stores, salons, cafes, clinics, boutiques, opticians, and neighborhood shops.</P>

      <H2>What we do</H2>
      <P>We turn any counter-top QR code into a customer database. A customer scans, enters name and mobile number, and joins the vendor's WhatsApp list in five seconds. Vendors can then send Meta-approved WhatsApp campaigns — offers, reminders, festival wishes — in one click.</P>

      <H2>Why we built this</H2>
      <UL>
        <li>85% of small Indian shops still keep customer lists in a notebook or lose them entirely.</li>
        <li>WhatsApp is where 90% of Indians actually read messages — SMS and email have died for retail.</li>
        <li>Existing CRMs are built for large enterprises with monthly plans starting at ₹5,000+ — unaffordable for a ₹15,000/month kirana store.</li>
      </UL>
      <P>Vendorly costs ₹99 for the first month, ₹199/month after. No auto-renewal, no long contracts, no per-message surcharges.</P>

      <H2>Our company</H2>
      <UL>
        <li><strong>Business name:</strong> Vendorly (operated by Dikshant Agarwal)</li>
        <li><strong>Domain:</strong> grahakly.app</li>
        <li><strong>Country:</strong> India</li>
        <li><strong>Contact:</strong> vendorlyadmin@gmail.com</li>
      </UL>

      <H2>Our promise</H2>
      <P>We will never sell customer phone numbers, spam recipients, or share data with third parties without a vendor's explicit consent. Every WhatsApp message is sent via Meta-approved templates through licensed Twilio infrastructure.</P>
    </LegalLayout>
  );
}
